export type PaymentType = 'PREPAY' | 'PER_SESSION';

export type TicketType = '1:1 수업';

export interface PaymentRequest {
    paymentRequestId: string;
    paymentType: PaymentType;
    memberName: string;
    trainerName: string;
    trainerProfileUrl?: string;
    ticketName: string;
    ticketType: TicketType;
    totalPrice: number;
    perSessionPrice: number;
    sessionCount: number;
    durationMonths: number;
    availableTime: string;
    availableDays: string[];
    startDate: string;
    endDate: string;
    /** 배너·모의 PG·판매자 정보(이용 센터) 등에 표시하는 수강 시설명 */
    centerName: string;
}

const DUMMY_PAYMENT_REQUESTS: PaymentRequest[] = [
    {
        paymentRequestId: 'demo-prepay-001',
        paymentType: 'PREPAY',
        memberName: '김라포',
        trainerName: '박트레이너',
        ticketName: '1:1 PT 20회 패키지',
        ticketType: '1:1 수업',
        totalPrice: 500000,
        perSessionPrice: 25000,
        sessionCount: 20,
        durationMonths: 3,
        availableTime: '10:00 ~ 22:00',
        availableDays: ['월', '화', '수', '목', '금'],
        startDate: '2026.03.20',
        endDate: '2026.06.19',
        centerName: '테스트센터',
    },
    {
        paymentRequestId: 'demo-session-001',
        paymentType: 'PER_SESSION',
        memberName: '이라포',
        trainerName: '최트레이너',
        ticketName: '1:1 PT 12회 패키지',
        ticketType: '1:1 수업',
        totalPrice: 600000,
        perSessionPrice: 50000,
        sessionCount: 12,
        durationMonths: 2,
        availableTime: '09:00 ~ 21:00',
        availableDays: ['월', '화', '수', '목', '금', '토'],
        startDate: '2026.03.20',
        endDate: '2026.05.19',
        centerName: 'Rappo 피트니스 강남점',
    },
];

export const getPaymentRequest = (id: string): PaymentRequest | undefined => {
    return DUMMY_PAYMENT_REQUESTS.find((r) => r.paymentRequestId === id);
};

export const formatPrice = (price: number): string => {
    return price.toLocaleString('ko-KR');
};
